import React from 'react';

import * as Runs from '../util/runs';
import CollapsibleJSONTable from './CollapsibleJSONTable';

interface RunSummaryTableProps {
  summary: any; // Receives raw config (json object)
  viewRawData: () => void;
}

const RunSummaryTable: React.FC<RunSummaryTableProps> = React.memo(
  ({summary, viewRawData}) => {
    const cleanedSummary = Object.entries(Runs.cleanSummary(summary)).reduce(
      (acc: {[key: string]: any}, [key, value]) => {
        if (
          key !== '_runtime' &&
          key !== '_step' &&
          key !== '_timestamp' &&
          !key.startsWith('gradients/') &&
          !key.startsWith('_wandb.') &&
          !key.startsWith('parameters/')
        ) {
          if (value?._type === 'table-file') {
            acc[key] = 'table-file';
          } else {
            acc[key] = value;
          }
        }
        return acc;
      },
      {}
    );
    return (
      <div className="run-config-table">
        <CollapsibleJSONTable data={cleanedSummary} viewRawData={viewRawData} />
      </div>
    );
  }
);

export default RunSummaryTable;
